import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const HERO_IMAGE = "https://public.readdy.ai/ai/img_res/b737173dd2ef5351bba0da0e79109ab0.jpg";

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = HERO_IMAGE;
    img.onload = () => setLoaded(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="BE:NAIL ネイルサロン"
          className={`w-full h-full object-cover object-top transition-opacity duration-700 ${loaded ? "opacity-100" : "opacity-0"}`}
        />
        {!loaded && <div className="w-full h-full bg-[#3D2E2A]" />}
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-20">
        <div className="max-w-2xl">
          {/* Tag */}
          <div className="inline-flex items-center gap-2 border border-[#C9A86A]/60 bg-white/10 backdrop-blur-sm px-4 py-1.5 rounded-full mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-[#C9A86A]" />
            <span className="text-[#C9A86A] text-xs tracking-[0.2em] uppercase" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              40代からの上質なネイル体験
            </span>
          </div>

          {/* Main Copy */}
          <h1 className="text-5xl lg:text-7xl text-white leading-tight mb-6" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300, lineHeight: 1.3 }}>
            あなたの指先に、<br />
            <span className="text-[#C9A86A]">洗練された</span><br />
            輝きを
          </h1>

          {/* Sub Copy */}
          <p className="text-white/75 text-base mb-10 leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            御堂筋線XX駅徒歩5分 ｜ 経験豊富なネイリストが丁寧に施術<br />
            上質な時間と確かな技術で、大人の女性を美しく彩ります
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <Link
              to="/booking"
              className="inline-flex items-center gap-2 bg-[#B8956A] text-white px-8 py-4 rounded-full text-sm font-medium tracking-widest hover:bg-[#A07B55] transition-all cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-2-line text-sm" /></span>
              ご予約はこちら
            </Link>
            <Link
              to="/gallery"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/40 text-white px-8 py-4 rounded-full text-sm font-medium tracking-widest hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              施術ギャラリーを見る
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm" /></span>
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-10 mt-16 pt-8 border-t border-white/20">
            {[
              { num: "12+", label: "年の実績" },
              { num: "1,000+", label: "満足のお客様" },
              { num: "3名", label: "専属ネイリスト" },
            ].map(({ num, label }) => (
              <div key={label}>
                <p className="text-[#C9A86A] text-2xl font-light mb-0.5" style={{ fontFamily: "'Noto Serif JP', serif" }}>{num}</p>
                <p className="text-white/60 text-xs tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>SCROLL</span>
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/50 text-sm"></i>
        </span>
      </div>
    </section>
  );
}
